export interface ClackSkuConfig {
  sku: string;
  targetQuantity: number | null;
  minimumTaskQuantity: number | null;
}

export interface ClackData {
  skuConfigs: ClackSkuConfig[];
}

export const CLACK_REPLENISHMENT_TASK_NOTE = 'clack replenishment';

export const DEFAULT_CLACK_DATA: ClackData = {
  skuConfigs: [
    {
      sku: 'C1030-00-159',
      targetQuantity: null,
      minimumTaskQuantity: null,
    },
    {
      sku: 'C1040-00-159',
      targetQuantity: null,
      minimumTaskQuantity: null,
    },
    {
      sku: 'C1050-00-159',
      targetQuantity: null,
      minimumTaskQuantity: null,
    },
  ],
};

/** Read older min/max settings without changing the saved inventory target. */
export function normalizeClackData(data: unknown): ClackData {
  const stored = data as { skuConfigs?: Record<string, unknown>[] } | null;
  const configs = stored?.skuConfigs;
  if (!Array.isArray(configs)) {
    return {
      skuConfigs: DEFAULT_CLACK_DATA.skuConfigs.map((config) => ({
        ...config,
      })),
    };
  }

  return {
    skuConfigs: configs
      .map((config) => {
        const target =
          config?.['targetQuantity'] !== undefined
            ? config['targetQuantity']
            : config?.['maximumQuantity'];

        return {
          sku: String(config?.['sku'] ?? '')
            .trim()
            .toUpperCase(),
          targetQuantity: Number.isFinite(target) ? Number(target) : null,
          minimumTaskQuantity: Number.isFinite(config?.['minimumTaskQuantity'])
            ? Number(config['minimumTaskQuantity'])
            : null,
        };
      })
      .filter((config) => !!config.sku),
  };
}
